import axios from 'axios'

export const api = axios.create({
  baseURL:
    import.meta.env.VITE_API_BASE_URL ||
    'https://api.adamimotors.com/api',

  withCredentials: true,
  withXSRFToken: true,

  headers: {
    Accept: 'application/json',
  },
})

const backendUrl = api.defaults.baseURL.replace(/\/(?:api|v1)\/?$/, '')
export const csrf = () =>
  axios.get(`${backendUrl}/sanctum/csrf-cookie`, {
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })

// This host's IIS/Plesk PHP handler does not reliably deliver real PUT/PATCH/DELETE
// requests to Laravel. Spoof them as POST with the override header, which Laravel
// (via Symfony's Request::getMethod) unconditionally honors.
api.interceptors.request.use(config => {
  const method = config.method?.toLowerCase()
  if (method === 'put' || method === 'patch' || method === 'delete') {
    config.headers = config.headers || {}
    config.headers['X-HTTP-METHOD-OVERRIDE'] = method.toUpperCase()
    config.method = 'post'
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) window.dispatchEvent(new Event('adami:unauthorized'))
    return Promise.reject(error)
  },
)

export const errorMessage = error => {
  const errors = error.response?.data?.errors
  if (errors) return Object.values(errors).flat()[0]
  return error.response?.data?.message || 'The request could not be completed. Please try again.'
}
